<template>
  <div>
    <!-- 强更新配置编辑弹窗 -->
    <EditForceUpdateConfigDialog v-if="visible('EditForceUpdateConfigDialog')"  />

    <!-- 热更配置编辑框 -->
    <EditHotUpdateConfigDialog v-if="visible('EditHotUpdateConfigDialog')" />
  </div>
</template>

<script>
import EditForceUpdateConfigDialog from "@/pages/version/tab-pages/EditForceUpdateConfigDialog";
import EditHotUpdateConfigDialog from "@/pages/version/tab-pages/EditHotUpdateConfigDialog";

export default {
  components: {
    EditForceUpdateConfigDialog,
    EditHotUpdateConfigDialog,
  },

  methods:{
    visible(name){
      if (this.$dialogutil.visible(name) == undefined) {
        this.$dialogutil.registerModule(name)
      }
      
      return this.$dialogutil.visible(name)
    }
  }
};
</script>
